import React from 'react';
import OrdersNavigator from '@fiverr-private/orders_navigator/src/components/OrdersNavigator';
import { localeSettings, user, headerType } from '../../PropTypes';
import { BUSINESS_PRO } from '../../constants';

import './style.scss';

const Orders = (props, { locale, user, headerType }) => {
    const business = headerType === BUSINESS_PRO ? user.business : undefined;
    return <OrdersNavigator locale={locale} business={business} />;
};

Orders.contextTypes = {
    locale: localeSettings.locale,
    user,
    headerType,
};

export default Orders;
